import React, {Component} from "react";
import {  Row, Col, ListGroup, ListGroupItem, Modal, ModalHeader, ModalBody, ModalFooter, Progress, Collapse, CardBody, UncontrolledTooltip, Button } from "reactstrap";
import Dropzone from "react-dropzone";
import { post } from "axios";
import { withRouter } from "react-router";
import "react-toggle/style.css"; 
import Toggle from "react-toggle";
import moment from "moment";
import JSMpeg from "jsmpeg-player";
import Proptypes from "prop-types";
import "rc-slider/assets/index.css";
import { connect } from "react-redux";
import Slider,{createSliderWithTooltip} from "rc-slider";
import DropzoneComponent from 'react-dropzone-component';
import ReactDOMServer from 'react-dom/server';
import { NotificationManager } from "react-notifications";
import stopReload from "../../constants/Constants";
import { destroyKasmShareId, createKasmShareId} from "../../actions/actionDashboard";

const SliderWithTooltip = createSliderWithTooltip(Slider);

const marks = {

    0: <strong>Static</strong>,
    1: <strong>Low</strong>,
    2: <strong>Medium</strong>,
    3: {
        style: {
            color: "red",
        },
        label: <strong>High</strong>,
    },
};


var player;
var keepAlive;       
var renderNav; 

class ControlPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            showNav: false,
            downloads: [],
            files: [],
            audio: true,
            microphone: true,
            collapse: false,
            currentIndex: null,
            modalclipboard: false,
            modaldownload: false,
            modalvideo: false,
            modaluploads: false,
            modaldestory: false,
            modalsharing: false,
            shareLink: null,
            message: null,
            disableIndex: [],
            clipboardText: "",
            modalAdvanced: false,
            destroyClicked: false,
            linkError: "",
            firstClick: false,
            clipboardUp: false,
            clipboardDown: false,
            logoutAll: false,
        };
        this.componentConfig = {
              postUrl: `https://${this.props.statusKasms.hostname}:${this.props.statusKasms.port_map.uploads.port}/${this.props.statusKasms.port_map.uploads.path}/upload`,
        };
        this.djsConfig = {
              withCredentials: true,
              autoProcessQueue: true,
              paramName: 'file',
              maxFilesize: 200 *1024*1024*1024, //Have to set a max file size
              maxFiles: null,
              parallelUploads: 10,
              chunking: true,
              chunkSize: 10000000,
              forceChunking: true,
              timeout: 0,
              dictDefaultMessage: "Drop Files Here or Select Box to Add Files",
              previewTemplate: ReactDOMServer.renderToStaticMarkup(<div></div>)
        };

        this.dropzone = null;

        this.showNav = this.showNav.bind(this);
        this.hideNav = this.hideNav.bind(this);
        this.toggleNav = this.toggleNav.bind(this);
        this.refreshNavState = this.refreshNavState.bind(this);
        this.confirmLogout = this.confirmLogout.bind(this);
        this.cancelLogout = this.cancelLogout.bind(this);
        this.destoryKasmsFun = this.destoryKasmsFun.bind(this);
        this.showLogout = this.showLogout.bind(this);
        this.showDestroy = this.showDestroy.bind(this);
        this.toggleLogout = this.toggleLogout.bind(this);
        this.toggleDownload = this.toggleDownload.bind(this);
        this.toggleClipboard = this.toggleClipboard.bind(this);
        this.toggleSharing = this.toggleSharing.bind(this);
        this.toggleUploads = this.toggleUploads.bind(this);
        this.toggleDestory = this.toggleDestory.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleVideo = this.toggleVideo.bind(this);
        this.showMessage = this.showMessage.bind(this);
        this.downloadsList = this.downloadsList.bind(this);
        this.handleClipboard = this.handleClipboard.bind(this);
        this.handleAudioChange = this.handleAudioChange.bind(this);
        this.handleMicrophoneChange = this.handleMicrophoneChange.bind(this);
        this.destroyAudio = this.destroyAudio.bind(this);
        this.connectAudio = this.connectAudio.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleAudioProcess = this.handleAudioProcess.bind(this);
        this.destroyMicrophone = this.destroyMicrophone.bind(this);
        this.connectMicrophone = this.connectMicrophone.bind(this);
        this.receiveMessage = this.receiveMessage.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.toggleAdvanced = this.toggleAdvanced.bind(this);
        this.handlePreferLocalCursorChange = this.handlePreferLocalCursorChange.bind(this);
        this.setPreferLocalCursor = this.setPreferLocalCursor.bind(this);
        this.handleUploadprogress = this.handleUploadprogress.bind(this);
        this.handleAddedFile = this.handleAddedFile.bind(this);
        this.handleSuccessFile = this.handleSuccessFile.bind(this);
        this.bytesToSize = this.bytesToSize.bind(this);
        this.resetDropzone = this.resetDropzone.bind(this);
        this.handleError = this.handleError.bind(this);
        this.clearFiles = this.clearFiles.bind(this);
        this.fileCanceled = this.fileCanceled.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.handleCreateShareLink = this.handleCreateShareLink.bind(this);
        this.handleDestroyShareLink = this.handleDestroyShareLink.bind(this);
        this.onUnlocked = this.onUnlocked.bind(this);
        this.reSyncAudio = this.reSyncAudio.bind(this);
        this.updateLogoutAll = this.updateLogoutAll.bind(this);
    }

    handleError(file) {
        let copy = this.state.files.slice();
        for (let i =0; i < copy.length; i++) {
            if (file.name === copy[i].name) {
                copy[i].error = file.xhr.response;
                copy[i].color = "danger";
                this.setState({files: copy});
            }
        }
    }

    fileCanceled(file, xhr, formData) {
        xhr.ontimeout = function (e) {
            alert("Error canceled upload. Most likely due to network issues.");
        }
    }

    clearFiles() {
        let copy = this.state.files.slice();
        for (let i =0; i < copy.length; i++) {
            this.dropzone.removeFile(copy[i].file);
        }
        this.setState({files: []});
    }

    resetDropzone() {
        this.dropzone.removeAllFiles();
    }

   removeFile(file) {
        this.dropzone.removeFile(file.file);
        let copy = this.state.files.slice();
        for (let i =0; i < copy.length; i++) {
            if (copy[i].name === file.name) {
                copy.splice(i,1);
                this.setState({files: copy});
            }
        }
   }

    handleAddedFile(file) {
        let copy = this.state.files.slice();
        let size = this.bytesToSize(file.size);
        copy.push({file: file, name:file.name, size:size, error:"", color:'info', progress: 0})
        this.setState({ files: copy });
    }

    bytesToSize(bytes) {
       var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
       if (bytes == 0) return '0 Byte';
       var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
       return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }

    handleCreateShareLink() {
        this.props.createKasmShareId(this.props.statusKasms.kasm_id)
            .then(() => {
                const {createShareError, share_id} = this.props;
                if (createShareError) {
                    this.setState({
                        shareLink: share_id,
                        linkError: createShareError,
                    });
                    this.props.shareEnabled(false);
                } else
                    this.setState({
                        shareLink: share_id,
                        linkError: "",
                    });
                    if (!this.props.disableFixedRes){
                        this.setState({videoQuality: 0});
                        this.props.setVideoQuality(0, true);
                    }
                    this.props.shareEnabled(true);
            })
            .catch(() => {
                const {createShareError, share_id} = this.props;
                this.setState({
                    shareLink: share_id,
                    linkError: "Error Creating Link"
                });
                this.props.shareEnabled(false);
            });
    }

    handleDestroyShareLink() {
        this.props.destroyKasmShareId(this.props.statusKasms.kasm_id)
            .then(() => {
                const {createShareError, share_id} = this.props;
                if (createShareError) {
                    this.setState({
                        shareLink: share_id,
                        linkError: createShareError
                    });
                    this.props.shareEnabled(false);
                } else
                    this.setState({
                        shareLink: share_id,
                        linkError: "",
                        videoQuality: 2
                    });
                this.props.setVideoQuality(2, true);
                this.props.shareEnabled(false);
            })
            .catch(() => {
                const {createShareError, share_id} = this.props;
                console.log(createShareError);
                this.setState({
                    shareLink: share_id,
                    linkError: "Error Destroying Link"
                });
                this.props.shareEnabled(false);
            });
    }

    handleSuccessFile(file) {
        setTimeout(function() {
            let copy = this.state.files.slice();
            for (let i =0; i < copy.length; i++) {
                if (copy[i].name === file.name) {
                    copy.splice(i,1);
                    this.setState({files: copy});
                }
            }
        }.bind(this), 2000)
    }

    handleUploadprogress (file, progress, bytesSent) {
        let copy = this.state.files.slice();
        for (let i =0; i < copy.length; i++) {
            if (file.name === copy[i].name) {
                 let progressChunk = progress;
                 progressChunk = Math.round( (bytesSent / file.size) * 100 );
                 copy[i].progress = progressChunk;
                 if (progressChunk === 100)
                    copy[i].color = "success";
                 this.setState({files: copy});
            }
        }
    }

    handleAudioChange(e){
        let value = e.target.checked;
        value ? this.connectAudio() : this.destroyAudio();
        this.setState({
            audio: value
        });
    }

    handleMicrophoneChange(e){
        let value = e.target.checked;
        value ? this.connectMicrophone() : this.destroyMicrophone();
        this.setState({
            microphone: value
        });
    }

    handlePreferLocalCursorChange(e){
        let value = e.target.checked;
        this.setPreferLocalCursor(value);
    }

    setPreferLocalCursor(v){
        window.localStorage.setItem('prefer_local_cursor', v);
    }

    showLogout(){
        this.setState({
            modal: true,
            showNav: false
        });
    }

    showDestroy(){
        this.setState({
            modaldestory: true,
            showNav: false
        });
    }

    confirmLogout(){
        this.toggleLogout();
        window.removeEventListener("beforeunload", stopReload, true);
        let logout_data = {logout_all: this.state.logoutAll};
        this.props.logout(logout_data);
    }
    
    destoryKasmsFun (){
        this.props.destoryKasms(this.props.statusKasms.kasm_id).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
        this.setState({destroyClicked: true});
        this.props.toggleLoader();
        this.toggleDestory();
    }

    handleDeleteSuccess(){
        const {destoryKasmsErrorMessage} = this.props;
        if(destoryKasmsErrorMessage) {
            NotificationManager.error(destoryKasmsErrorMessage,"Delete Kasm", 3000);
        }
        else{
            this.props.history.push("/userdashboard");
        }
    }

    handleDeleteError(){
        const {deleteKasmsError} = this.props;
        if(deleteKasmsError){
            NotificationManager.error(deleteKasmsError,"Delete Kasm", 3000);
        }
        else{
            NotificationManager.error("Failed to Delete Kasm","Delete Kasm", 3000);
        }
    }

    componentDidMount(){
        if (this.props.statusKasms.share_id) {
            this.setState({shareLink: this.props.statusKasms.share_id});
            this.props.shareEnabled(true);
        }

        if (this.props.disconnect) {
            this.setState({showNav: false});
        }

        if (this.props.show_tips === true) {
            renderNav = setTimeout(() => {
                this.hideNav();
            }, 3000);
        } else {
            this.setState({showNav: false});
        }

        this.props.updateKeepalive(this.props.statusKasms.kasm_id);
        keepAlive = setInterval(() => {
            this.props.updateKeepalive(this.props.statusKasms.kasm_id)
                .then((data) => {
                        if (data.response && data.response.usage_reached) {
                            NotificationManager.error("Kasm Usage Limit Reached","Kasm Usage Limit", 3000);
                            this.props.history.push("/");
                        }
                });
        }, 300000);

        if (this.props.statusKasms && this.props.statusKasms.client_settings){
            this.setState({
                clipboardUp: this.props.statusKasms.client_settings.allow_kasm_clipboard_up,
                clipboardDown: this.props.statusKasms.client_settings.allow_kasm_clipboard_down,
            });
        }
        // Add audio for when the domain already allows audio and add event listener to re establish audio on first 
        // click to resolve sync problems

        if (this.props.statusKasms.client_settings && this.props.statusKasms.client_settings.allow_kasm_audio && this.props.statusKasms.client_settings.kasm_audio_default_on) {
            this.connectAudio();
            window.addEventListener("mousedown", this.reSyncAudio);
            window.addEventListener('touchstart', this.reSyncAudio, false);
        } else {
            this.setState({firstClick: true})
        }

        if (window.addEventListener) {
            window.addEventListener("message", this.receiveMessage, false);
        } else if (window.attachEvent) { 
            window.attachEvent("message", this.receiveMessage);
        }  
        this.setState({modal: false});

        window.addEventListener("blur",() => {  
            renderNav = setTimeout(() => {
                if (document.activeElement instanceof HTMLIFrameElement) {
                    this.hideNav();
                }
            }, 10);
        });
    }

    onUnlocked () {
        if (typeof player !== undefined) {
            player.volume = 1;
        }
    }

    reSyncAudio() {
        window.removeEventListener("mousedown", this.reSyncAudio);
        window.removeEventListener('touchstart', this.reSyncAudio);
        this.destroyAudio();
        this.connectAudio();
    }

    connectAudio(){
        const{statusKasms}=this.props;
        const audio_url = `wss://${statusKasms.hostname}:${statusKasms.port_map.audio.port}/${statusKasms.port_map.audio.path}/`;
        this.setState({audio_url});
        var canvas = document.getElementById("video-canvas");
        player = new JSMpeg.Player(audio_url, {canvas: canvas});

        // mobile Fix: try to unlock immediately
        if (player && player.audioOut) {
            player.audioOut.unlock(this.onUnlocked);
        }

    }

    destroyAudio() {
        if (typeof player !== undefined)
            try {
                player.destroy();
            } catch (err) {
                console.log(err);
                player = null;
            }
    }

    handleAudioProcess(event){
        if (this.mic_ws.readyState === WebSocket.OPEN){
            this.mic_ws.send(event.inputBuffer.getChannelData(0));
        }
    }

    handleSuccess(stream) {
            this.stream = stream;
            let AC = window.AudioContext || window.webkitAudioContext;
            this.audio_context = new AC();
            const source = this.audio_context.createMediaStreamSource(stream);

            const{statusKasms}=this.props;
            const microphone_url = `wss://${statusKasms.hostname}:${statusKasms.port_map.audio_input.port}/${statusKasms.port_map.audio_input.path}/?sample_rate=${source.context.destination.context.sampleRate}`;
            this.setState({microphone_url});
            this.mic_ws = new WebSocket(microphone_url);

            const processor = this.audio_context.createScriptProcessor(2048, 1, 1);
            source.connect(processor);
            processor.connect(this.audio_context.destination);
            processor.onaudioprocess = this.handleAudioProcess
    };

    connectMicrophone(){
        navigator.mediaDevices.getUserMedia({audio: true, video: false})
            .then(this.handleSuccess);
    }

    destroyMicrophone() {
        if (this.mic_ws){
            this.mic_ws.close();
        }
        if (this.stream){
            for (let track in this.stream.getAudioTracks()){
                this.stream.getAudioTracks()[track].stop()
            }
        }
        if (this.audio_context) {
            this.audio_context.close();
        }
    }

    componentWillUnmount(){
        this.destroyAudio();
        this.destroyMicrophone();
        clearInterval(keepAlive);
        clearInterval(renderNav);
        window.removeEventListener('touchstart', this.reSyncAudio);
        window.removeEventListener("mousedown", this.reSyncAudio);
    }

    cancelLogout(){
        this.toggleLogout();
        this.props.history.push("/");
    }

    showNav(){
        this.setState({ showNav: true });
        this.refreshNavState()
    }

    hideNav(){
        this.setState({ showNav: false });
    }

    toggleNav(){
        this.setState({ showNav: !this.state.showNav });
        this.refreshNavState();
    }

    refreshNavState(){
        // If the nav is open then refresh the contents if necessary
        if (this.state.modaldownload){
            this.downloadsList();
        }

        // If the clipboard modal is open. Auto select the text. This should make the workflow of copy paste much faster
        if (this.state.modalclipboard){
            // Chrome has a bug where the select doesnt apply immediately. Using set timeout gets around this.
            document.getElementById('clipboardtext').focus();
            setTimeout(function () { document.getElementById('clipboardtext').select(); }, 50);
        }
    }

    toggleLogout(){
        this.setState({ modal: !this.state.modal });   
    }

    toggleDownload(){
        if (this.state.modaldownload === false)
            this.downloadsList();
        this.setState({ modaldownload: !this.state.modaldownload });
    }

    toggleVideo(){
        this.setState({ modalvideo: !this.state.modalvideo });
    }

    toggleSharing(){
        this.setState({ modalsharing: !this.state.modalsharing });
    }

    toggleAdvanced(){
        this.setState({ modalAdvanced: !this.state.modalAdvanced });
    }

    toggleClipboard(){
        this.setState({ modalclipboard: !this.state.modalclipboard });   
    }

    toggleUploads(){
        this.setState({ modaluploads: !this.state.modaluploads, files: [], currentIndex: null, disableIndex: [], fileStatusArr: [] , progress: 0 });   
    }

    toggleDestory(){
        this.setState({ modaldestory: !this.state.modaldestory });   
    }

    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }

    handleClose(e) {
        this.props.history.push("/")
    }

    receiveMessage(event) {
        if (event.data && event.data.action == "clipboardrx") {
            if (this.state.clipboardDown){
                this.setState({clipboardText: event.data.value});
            }
        }
        else if (event.data && event.data.action == "disconnectrx" && !this.state.destroyClicked) {
            this.props.handleDisconnect();
        } else if ( event.data.action == "togglenav")
            this.toggleNav();
        else if ( event.data.action == "idle_session_timeout") {
            window.disableAPIActiveState = 1;
            setTimeout(function() {
                window.disableAPIActiveState = 0;
	    }, 5000);
            this.props.history.push("/");
            
        } else if (event.data.action == "firstClick") {
            if (!this.state.firstClick)
                this.reSyncAudio();
                this.setState({firstClick: true});
        } else if (event.data.action == "firstTouch") {
            if (!this.state.firstClick)
                this.reSyncAudio();
                this.setState({firstClick: true});
        }
    }

    showMessage(i){
        const {fileStatusArr} = this.state;
        let element = "";

        element = fileStatusArr.find(function(element) {return element.index === i;});

        if(element){
            if(element && element["success-status"]){
                return  <span className="text-success blk_inline mt-7"> {element["success-status"]} </span>;
            }
            else if(element && element["failure-status"]){
                return  <span className="text-danger blk_inline mt-7"> {element["failure-status"]} </span>;
            }            
        }
        return  " ";
    }

     // FIXME KASM-365 This function doesnt actually trigger an update to the DOM to show the download lists. Rather, another
    //  bug that continuously refreshes the page causing the downloads to re-appear
    async downloadsList(path) {
        const{statusKasms}=this.props;
        let _path = path;
        if (_path === undefined){
            _path = '';
        }
        var url = `https://${statusKasms.hostname}:${statusKasms.port_map.vnc.port}/${statusKasms.port_map.vnc.path}/Downloads/Downloads/${_path}?_=${new Date().getTime()}`;
        var real_url = `https://${statusKasms.hostname}:${statusKasms.port_map.vnc.port}/${statusKasms.port_map.vnc.path}/Downloads/Downloads/${_path}`;
        var downloads=[];

        await fetch( url, {
            method: 'GET',
            credentials: "include"
        }).then((response) => {
            return response.text()
        }).then((data) => {
            if (statusKasms.operational_status === "running") {
                var doc = document.implementation.createHTMLDocument("doc");
                doc.documentElement.innerHTML = data;
                downloads.length = 0;
                var titles = doc.getElementsByTagName("title");
                var root = titles[0].innerText.split('?')[0].replace('Directory listing for /Downloads/Downloads/','');

                var items = doc.getElementsByTagName("a");
                for (var i = 0; i < items.length; i++) {
                    let is_dir = items[i].innerHTML.endsWith('/');
                    // Don't show symlinks
                    if (!items[i].innerHTML.endsWith('@')){
                        downloads.push(
                            {
                                name: items[i].innerHTML,
                                dlink: real_url + items[i].innerHTML,
                                is_dir: is_dir,
                                relative_path: root + items[i].innerHTML
                            }
                        );
                    }

                }
            }
        });
        this.setState({downloads: downloads});
    }

    handleClipboard(event) {
        // The websocket has a maxmium buffer size that can be safely sent.
        let maximumBufferSize=10000;
        let clipboardText = event.target.value.slice(0,maximumBufferSize);
        this.setState({clipboardText});

        if (this.state.clipboardUp){
            document.getElementById("iframe-id").contentWindow.postMessage( { action: "clipboardsnd", value: clipboardText }, "*");
        }
    }

    copyToClipboard(str) {
        const el = document.createElement('textarea');
        el.value = str
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    openWindow(url){
        window.open(url, "_blank", "resizable=yes,top=0,left=0,width=800,height=640");
    }

    updateLogoutAll() {
        this.setState({logoutAll: !this.state.logoutAll});
    }

    render() {
        const {disableIndex, progress, downloads, shareLink} = this.state;
        const {statusKasms} =this.props;
        const userInfo = JSON.parse(window.localStorage.user_info);
        const defaultPreferLocalCursor = window.localStorage.getItem('prefer_local_cursor') ? JSON.parse(window.localStorage.getItem('prefer_local_cursor')) : true;

        const config = this.componentConfig;
        const djsConfig = this.djsConfig;

        const progressBars = this.state.files.map((file) =>
            <div key={file.name}>
            <strong>{file.name}</strong>  <span className="float-right" style={{}}>{file.size}&nbsp;&nbsp;&nbsp;
            <button style={{   'background':'none',
                                'border':'none',
                                 'margin':'0',
                                 'padding':'0',
                                 'cursor': 'pointer',
                                 'color': 'red'
                }} onClick={() => this.removeFile(file)}>✘</button></span>
            <Progress animated className="pd=15" color={file.color} value= {file.progress} />
            {file.error ? <span style={{'color':'red'}}> {file.error} </span> : file.progress===100 ? "File Complete" : ""}

            </div>
        );

        const eventHandlers = {
          init: (dz) => (this.dropzone = dz),
          addedfile: this.handleAddedFile,
          success: this.handleSuccessFile,
          uploadprogress: this.handleUploadprogress,
          error: this.handleError,
          sending: this.fileCanceled,
          queuecomplete: this.resetDropzone
        };




        // Send an event to the parent document (kasm app) to toggle the control panel when ctl is double clicked

        var delta = 500;
        var lastKeypressTime = 0;
        if (this.props.toggle_control_panel === true) {
              document.addEventListener('keyup', (event) => {
                const keyName = event.key;
                // CTRL and the various implementations of the mac command key
                if ([17,224,91,93].indexOf(event.keyCode) > -1) {
                    let thisKeypressTime = new Date();
                    if (thisKeypressTime - lastKeypressTime <= delta) {
                        this.toggleNav();
                        thisKeypressTime = 0;
                    }
                    lastKeypressTime = thisKeypressTime;
                }
            }, true);

        }

        const navOverride = this.props.hideControlPanel ? {display : "None"} : {};
        return (


            <div>
                <canvas id="video-canvas"/>
                <i id="nav_toggle" className="fa fa-ellipsis-v toggle_icon" onClick={this.showNav} aria-hidden="true" style={navOverride}/>
                <div id="mySidenav" className={this.state.showNav && !this.props.hideControlPanel ?  "sidenav show_nav" : "sidenav hide_nav"} >
                    <a href="javascript:void(0)" className="fa fa-close closebtn" onClick={() => this.hideNav()} />
                    <a className="sidenav3 sidenav-general toggle_nav" data-target="#collapseExample" onClick={this.toggle}>
                        <i className = "fa fa-desktop" aria-hidden="true"></i>  Kasm ID :<span> {statusKasms.kasm_id.substring(0, 6)}</span>
                        <span style = {{ "visibility" : "hidden" }} >  Connection Strength : </span><span  style = {{ "visibility" : "hidden" }} >Poor  </span>
                        <i style= {{color : "Red", "visibility" : "hidden" }} className="fa fa-signal"></i>
                        <span>
                        <button className="btn btn-dark btn-sm"  onClick={() => this.handleClose()}> Home</button>
                        <button className="btn btn-dark btn-sm"  onClick={() => this.showLogout()}> Logout</button>
                        <button className="btn btn-dark btn-sm"  onClick={() => this.showDestroy()}> Destroy </button>
                        </span>
                        <span className="toggle_arrow_icon">
                            { this.state.collapse ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"> </i> }
                        </span>
                    </a>

                    <Collapse isOpen={this.state.collapse} id="collapseExample" className="toggle_panel para_border">
                        <CardBody>
                            <p> <span>User</span> {userInfo.username}</p>
                            <p> <span>Image</span> {statusKasms.image.friendly_name}</p>
                            <p> <span>Expiration</span> {moment.utc(moment.utc(statusKasms.expiration_date).diff(moment.utc(statusKasms.current_time), "hh:mm" )).format("HH:mm")}</p>
                            <p> <span>URL</span>
                                <button className="btn btn-link p-0" onClick={() => {this.openWindow("https://" + window.location.host + window.location.pathname + "#/kasm/" + statusKasms.kasm_id.substring(0, 6))}} >{"https://" + window.location.host + window.location.pathname  + "#/kasm/" + statusKasms.kasm_id.substring(0, 6)}</button>
                                <button className="btn btn-default btn-sm" onClick={() => {this.copyToClipboard("https://" + window.location.host + window.location.pathname + "#/kasm/" + this.props.statusKasms.kasm_id.substring(0, 6))}}><i className = "fa fa-copy" aria-hidden="true"></i></button>
                            </p>
                        </CardBody>
                    </Collapse>

                    {statusKasms.client_settings.allow_kasm_clipboard_up || statusKasms.client_settings.allow_kasm_clipboard_down == true ?
                        <a className="sidenav1 sidenav-general toggle_nav" data-target="#collapseClipboard" onClick={this.toggleClipboard}> <i className="fa fa-clipboard" aria-hidden="true"></i>  Clipboard <span className="toggle_arrow_icon">{ this.state.modalclipboard ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"> </i> } </span> </a>
                        : <a className="sidenav1 sidenav-general toggle_nav"> <i className="fa fa-cloud-download" aria-hidden="true"></i>  <span className="disable_txt">Clipboard</span> <span style = {{"color":"#f2a025", "marginLeft":"30px", "fontWeight":"bold"}}> Disabled by Administrator </span> <span className="toggle_arrow_icon"> <i className="fa fa-angle-right"></i></span> </a>
                    }

                    <Collapse isOpen={this.state.modalclipboard} id="collapseClipboard" className="toggle_panel">
                        <CardBody>
                            <p> The contents of the Kasm Desktop clipboard will be available in the text area below.</p>                            
                            <p> Enter text in the text area below to make the content available to the Kasm Desktop </p>
                            {
                                statusKasms.client_settings.allow_kasm_clipboard_up === false ?
                                <span style = {{"color":"#f2a025", "fontWeight":"bold"}}> Pasting data to the Kasm is disabled.</span>
                                : ""
                            }
                            {
                                statusKasms.client_settings.allow_kasm_clipboard_down === false ?
                                <span style = {{"color":"#f2a025", "fontWeight":"bold"}}> Copying data from the Kasm is disabled.</span>
                                : ""
                            }

                            <textarea value={this.state.clipboardText} onChange={this.handleClipboard} className='clipboard-text form-control' rows="6" id='clipboardtext'></textarea>
                        </CardBody>
                    </Collapse>
                    

                    {statusKasms.client_settings.allow_kasm_downloads == true ? 
                        <a className="sidenav1 sidenav-general toggle_nav" data-target="#collapseDownload" onClick={this.toggleDownload}> <i className="fa fa-cloud-download" aria-hidden="true"></i>  Download <span className="toggle_arrow_icon">{ this.state.modaldownload ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"> </i> }</span> </a>
                        : <a className="sidenav1 sidenav-general toggle_nav"> <i className="fa fa-cloud-download" aria-hidden="true"></i>  <span className="disable_txt">Download</span> <span style = {{"color":"#f2a025", "marginLeft":"30px", "fontWeight":"bold"}}> Disabled by Administrator </span> <span className="toggle_arrow_icon"><i className="fa fa-angle-right"></i></span> </a>
                    }


                    <Collapse isOpen={this.state.modaldownload} id="collapseDownload" className="toggle_panel">
                        <CardBody>
                            <p> Items in the Kasm Desktop Downloads folder will be available to download to your computer here.</p>
                            <ListGroup>
                                {
                                    downloads.length > 0 && downloads.map((download)=>
                                    download.is_dir ?
                                        <ListGroupItem key={download.dlink}><a download onClick={() => this.downloadsList(download.relative_path)}>{download.name}</a></ListGroupItem>
                                        :
                                        <ListGroupItem key={download.dlink}><a href={download.dlink} download>{download.name}</a></ListGroupItem>
                                    )
                                }
                            </ListGroup>
                        </CardBody>
                    </Collapse>
                    
    
                    
                    {statusKasms.client_settings.allow_kasm_uploads == true ? 
                        <a className="sidenav1 sidenav-general toggle_nav" data-target="#collapseUpload" onClick={this.toggleUploads}> <i className="fa fa-cloud-upload" aria-hidden="true"></i> Upload <span  className="toggle_arrow_icon">{ this.state.modaluploads ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"> </i> }</span> </a>
                        : <a className="sidenav1 sidenav-general toggle_nav"> <i className="fa fa-cloud-upload" aria-hidden="true"></i> <span className="disable_txt">Upload</span> <span style = {{"color":"#f2a025", "marginLeft":"30px", "fontWeight":"bold"}}> Disabled by Administrator </span> <span className="toggle_arrow_icon"><i className="fa fa-angle-right"></i></span> </a>
                    }
                    
                    <Collapse isOpen={this.state.modaluploads} id="collapseUpload" className="toggle_panel">
                        <CardBody>
                            <div>
                                <DropzoneComponent
                                    className=""
                                    config={config}
                                    djsConfig={djsConfig}
                                    eventHandlers={eventHandlers}
                                />
                                {progressBars}
                                <div className="m-5">
                                {this.state.files.length > 0 ? <button className="mt-1 btn btn-danger"onClick={() => this.clearFiles()}>Clear all</button> : ""}
                                </div>
                                <br />
                             </div>
                        </CardBody>
                    </Collapse>


                    {statusKasms.client_settings.allow_kasm_audio == true ?
                        <a className="sidenav3 sidenav-general"> <i className = "fa fa-volume-up" aria-hidden="true"></i>  Audio <label> <Toggle onChange={this.handleAudioChange} defaultChecked={this.props.statusKasms.client_settings.kasm_audio_default_on} /> </label> </a>
                        :  <a className="sidenav1 sidenav-general toggle_nav"> <i className="fa fa-volume-up" aria-hidden="true"></i> <span className="disable_txt">Audio</span> <span style = {{"color":"#f2a025", "marginLeft":"30px", "fontWeight":"bold"}}> Disabled by Administrator </span> <label> <Toggle checked={false} /> </label> </a>
                    }

                    {statusKasms.client_settings.allow_kasm_microphone == true ?
                        <a className="sidenav3 sidenav-general"> <i className = "fa fa-microphone" aria-hidden="true"></i>  Microphone <label> <Toggle onChange={this.handleMicrophoneChange} defaultChecked={this.props.statusKasms.client_settings.kasm_microphone_default_on} /> </label> </a>
                        :  <a className="sidenav1 sidenav-general toggle_nav"> <i className="fa fa-microphone" aria-hidden="true"></i> <span className="disable_txt">Microphone</span> <span style = {{"color":"#f2a025", "marginLeft":"30px", "fontWeight":"bold"}}> Disabled by Administrator </span> <label> <Toggle checked={false} /> </label> </a>
                    }

                    {this.props.sharing && statusKasms.client_settings.lock_sharing_video_mode == true ?
                        <a className="sidenav1 sidenav-general toggle_nav" data-target="#collapseVideo"><i className="fa fa-youtube-play" aria-hidden="true"/>
                            <span className="disable_txt"> Video </span> <span style = {{"color":"#f2a025", "marginLeft":"30px", "fontWeight":"bold"}}> Disabled During Sharing </span>
                            <span className="toggle_arrow_icon">
                                {this.state.modalvideo ?
                                    <i className="fa fa-angle-down"/> :
                                    <i className="fa fa-angle-right"/>
                                }
                            </span>
                        </a>
                        :
                        <a className="sidenav1 sidenav-general toggle_nav" data-target="#collapseVideo"
                           onClick={this.toggleVideo}>
                            <i className="fa fa-youtube-play" aria-hidden="true"/> Video
                            <span className="toggle_arrow_icon">
                                <i className="fa fa-angle-right"/>
                            </span>
                        </a>
                    }

                    <Collapse isOpen={this.state.modalvideo} id="collapseVideo" className="toggle_panel">
                        <CardBody>
                            <p> If the responsiveness of the page is low reducing the video quality will improve response times.</p>
                            <ListGroup>
                                {
                                    <div className="video_white_bg">
                                        <SliderWithTooltip marks={marks} min={0} max={3} value={this.props.videoQuality} onChange={this.props.setVideoQuality.bind(this)} />
                                    </div>   
                                }
                            </ListGroup>
                        </CardBody>
                    </Collapse>

                    {statusKasms.client_settings.allow_kasm_sharing == true ?
                        <a className="sidenav1 sidenav-general toggle_nav" data-target="#collapseSharing" onClick={this.toggleSharing}>
                            <i className="fa fa-users" aria-hidden="true"/>  Sharing
                            <span className="toggle_arrow_icon">
                                { this.state.modalSharing ?
                                    <i className="fa fa-angle-down"/>
                                    : <i className="fa fa-angle-right"> </i> }
                            </span>
                        </a>
                        : <a className="sidenav1 sidenav-general toggle_nav">
                            <i className="fa fa-share" aria-hidden="true"/>
                            <span className="disable_txt">Sharing</span>
                            <span style = {{"color":"#f2a025", "marginLeft":"30px", "fontWeight":"bold"}}> Disabled by Administrator </span>
                            <span className="toggle_arrow_icon"> <i className="fa fa-angle-right"/></span>
                        </a>
                    }

                    <Collapse isOpen={this.state.modalsharing} id="collapseSharing" className="toggle_panel">
                        <CardBody>
                            <div style={{paddingBottom:'10px'}}>Share view-only access to this Kasm with other users.</div>
                            {shareLink ?
                                <div>
                                    <div className="d-flex">
                                        <button className="btn btn-danger btn-sm" onClick={this.handleDestroyShareLink}>Stop Sharing</button>
                                        <div className="share-link d-flex">
                                            <button className="btn btn-link share-btn"
                                                    onClick={() => {this.openWindow("https://" + window.location.host + window.location.pathname + "#/join/" + shareLink )}}
                                            >
                                                {"https://" + window.location.host + window.location.pathname  + "#/join/" + shareLink}
                                            </button>
                                            <button className="btn btn-default btn-sm"
                                                    onClick={() => {this.copyToClipboard("https://" + window.location.host + window.location.pathname + "#/join/" + shareLink)}}
                                            >
                                                <i className = "fa fa-copy" aria-hidden="true"/>
                                            </button>
                                        </div>
                                    </div>
                                    <div id="share_tips">
                                        <h4>Sharing Tips!</h4>
                                        <p>
                                            Any User with this link can view this Kasm and participate in chat.
                                        </p>
                                        <p>
                                            Changes to the video setting effect all viewers. When sharing is enabled, the
                                            resolution is fixed by default to ensure a consistent experience for all viewers.
                                        </p>
                                    </div>
                                </div>
                                :
                                <button className="btn btn-dark btn-sm" onClick={this.handleCreateShareLink}><i className="fa fa-share" />Share Kasm</button>
                            }

                            { this.state.linkError &&
                                <p style={{color:'red'}}>{this.state.linkError}</p>
                            }
                        </CardBody>
                    </Collapse>

                    <a className="sidenav1 sidenav-general toggle_nav" data-target="#collapseAdvanced"
                       onClick={this.toggleAdvanced}> <i className="fa fa-wrench" aria-hidden="true"></i> Advanced <span
                        className="toggle_arrow_icon">{ this.state.modalAdvanced ?
                        <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"> </i> }</span> </a>
                    <Collapse isOpen={this.state.modalAdvanced} id="collapseAdvanced" className="toggle_panel">
                        <CardBody>
                            <div>
                                <React.Fragment>

                                    <span id="prefer_local_cursor" className="align_middle">
                                        <b>Prefer Local Cursor</b>
                                    </span>
                                    &nbsp;
                                    <Toggle
                                        className="align_middle"
                                        id="prefer_local_cursor_toggle"
                                        onChange={this.handlePreferLocalCursorChange}
                                        defaultChecked={defaultPreferLocalCursor}/>
                                </React.Fragment>
                                <UncontrolledTooltip placement="bottom" target="prefer_local_cursor" delay={{show:100, hide:50}}
                                                     className="max_z">
                                    Prefer rending a local cursor on touch-enabled devices. Using a local cursor
                                    improves mouse responsiveness. Disable this setting to use a remote cursor which may
                                    improve touch gestures. Changes are applied when re-connecting to the Kasm.
                                </UncontrolledTooltip>
                            </div>
                        </CardBody>
                    </Collapse>
                </div>

                <Modal zIndex={999999} isOpen={this.state.modal} toggle={this.toggleLogout} >
                    <ModalHeader toggle={this.toggleLogout}>Logout <i className="fa fa-sign-out" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={{ size: 12}}>
                                <p>Are you sure you want to Logout?</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={{ size: 12}}>
                                <label id="force_label" >Logout of all sessions: &nbsp; &nbsp;<input type="checkbox" value={this.state.logoutAll} onChange={this.updateLogoutAll}/></label>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.confirmLogout} size="sm" color="primary"> <i className="fa fa-sign-out"></i> Logout</Button>
                        <Button onClick={this.toggleLogout} size="sm" color="basic"><i className="fa fa-ban"></i> Cancel</Button>
                    </ModalFooter>
                </Modal>

                <Modal zIndex={999999} isOpen={this.state.modaldestory} toggle={this.toggleDestory} >
                    <ModalHeader toggle={this.toggleDestory}>Destroy <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>    
                    <ModalBody>
                        <p>  Are you sure you want to destroy this Kasm?</p>
                    </ModalBody>             
                    <ModalFooter>
                        <Button onClick={this.destoryKasmsFun} size="sm" color="danger"> <i className="fa fa-sign-out"></i> Destroy</Button>
                        <Button onClick={this.toggleDestory} size="sm" color="basic"><i className="fa fa-ban"></i> Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}


ControlPanel.propTypes = {
    logout: Proptypes.func.isRequired,
    toggleLoader: Proptypes.func.isRequired,
    destoryKasms: Proptypes.func.isRequired,
    statusKasms: Proptypes.object,
    history: Proptypes.object,
    updateKeepalive: Proptypes.func.isRequired,
    kasmId: Proptypes.func,
    videoQuality: Proptypes.number,
    setVideoQuality: Proptypes.func,
    setVideoQualityStyle: Proptypes.func,
    handleDisconnect: Proptypes.func,
    shareEnabled: Proptypes.func.isRequired,
    hideControlPanel: Proptypes.bool,
    disableFixedRes: Proptypes.bool,
};

ControlPanel = withRouter(ControlPanel); // eslint-disable-line

export default connect(state =>
        ({
            share_id: state.dashboard.share_id || null,
            destroyShareLoading: state.dashboard.destroyShareLoading || null,
            destroyShareError: state.dashboard.destroyShareError || null,
            createShareLoading: state.dashboard.createShareLoading || null,
            createShareError: state.dashboard.createShareError || null,
        }),
    dispatch =>
        ({
            createKasmShareId: (data) => dispatch(createKasmShareId(data)),
            destroyKasmShareId: (data) => dispatch(destroyKasmShareId(data)),
        }))(ControlPanel);



// WEBPACK FOOTER //
// ./src/components/ControlPanel/ControlPanel.js